import Vue from 'vue';
import { gsap } from 'gsap/all';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

Vue.component('overlay-component', {
    data() {
        return {
            showOverlay: false,
            activeOverlayClass: false,
            triggerButton: null,
            triggerButtonRect: null,
            bg: null,
            overlayContainer: null,
            overlayHeight: 0,
            overlayWidth: 0,
        };
    },

    mounted() {
        this.triggerButton = this.$el.querySelector('.overlay__trigger-holder');
        this.triggerButtonRect = this.triggerButton.getBoundingClientRect();
        this.triggerButtonIcon = this.$el.querySelector('.overlay__trigger-holder svg');
        this.bg = this.$el.querySelector('.overlay__background');
        this.overlayContainer = this.$el.querySelector('.overlay__container');

        this.title = this.$el.querySelector('.overlay__title-holder');
        this.text = this.$el.querySelector('.overlay__text-holder');
        this.person = this.$el.querySelector('.overlay__person-details');
        this.contact = this.$el.querySelector('.overlay__contact-holder');

        EventBus.$on('window-resize', () => {
            this.triggerButtonRect = this.triggerButton.getBoundingClientRect();
        });

        // if (window.matchMedia('(max-width: 767px)').matches) {
        //     ScrollTrigger.create({
        //         trigger: '#page-wrapper',
        //         start: 'top -5%',
        //         onEnter: () => {
        //             gsap.to(this.$el.querySelector('.overlay__trigger-text'), { duration: 1, autoAlpha: 0, ease: 'power4.out' });
        //         },
        //         onLeaveBack: () => {
        //             gsap.to(this.$el.querySelector('.overlay__trigger-text'), { duration: 1, autoAlpha: 1, ease: 'power4.out' });
        //         },
        //     });
        // }
    },

    methods: {
        toggleOverlay() {
            this.showOverlay = !this.showOverlay;
            EventBus.$emit('disable-body-scoll', this.showOverlay);
        },

        overlayBeforeEnter() {
            this.activeOverlayClass = true;

            // 20 is the margin between triggerButton at the top & bottom (10 each)
            this.overlayHeight = window.innerHeight - 20 - this.triggerButtonRect.height;
            this.overlayWidth = window.innerWidth >= 768 && window.innerWidth < 1024 ? window.innerWidth * 0.77864583 : gsap.utils.clamp(598, 840, window.innerWidth * 0.58333333);

            gsap.set(this.overlayContainer, {
                width: window.innerWidth < 768 ? '100%' : this.overlayWidth,
                minHeight: window.innerWidth < 768 ? this.overlayHeight : '100%',
                y: window.innerWidth < 768 ? `+=${20 + this.triggerButtonRect.height}` : 0, // set 100% height - overlayHeight to prevent overlay to become visible before animation
            });

            gsap.set([this.title, this.text, this.person, this.contact], {
                autoAlpha: 0,
                y: 20,
            });
        },

        overlayEnter(el, done) {
            const tl = gsap.timeline();

            tl
                .to(this.bg, {
                    duration: 1,
                    autoAlpha: 1,
                    ease: 'power3.inOut',
                })
                .to(this.triggerButton, {
                    duration: 1,
                    y: window.innerWidth < 768 ? -window.innerHeight + this.triggerButtonRect.height + 20 : 0,
                    x: window.innerWidth < 768 ? 0 : -this.overlayWidth,
                    ease: 'power4.inOut',
                }, '<')
                .to(this.triggerButtonIcon, {
                    duration: 1,
                    rotate: 45,
                    ease: 'power3.inOut',
                }, '<')
                .to(this.overlayContainer, {
                    duration: 1,
                    y: window.innerWidth < 768 ? this.triggerButtonRect.height + 20 : 0,
                    // y: window.innerWidth < 768 ? 20 + this.triggerButtonRect.height : 0,
                    yPercent: 0,
                    x: window.innerWidth < 768 ? 0 : window.innerWidth - this.overlayWidth,
                    ease: 'power4.inOut',
                }, '<')
                .to([this.title, this.text], {
                    duration: 1.5,
                    autoAlpha: 1,
                    y: 0,
                    ease: 'power4.inOut',
                }, '<+0.2')
                .to(this.person, {
                    duration: 1.5,
                    autoAlpha: 1,
                    y: 0,
                    ease: 'power4.inOut',
                }, '<+0.1')
                .to(this.contact, {
                    duration: 1.5,
                    autoAlpha: 1,
                    y: 0,
                    ease: 'power4.inOut',
                    onComplete: done,
                }, '<+0.1')
                .to(this.$el.querySelector('.overlay__trigger-text'), {
                    duration: 0.2,
                    autoAlpha: 0,
                    ease: 'power4.inOut',
                }, 0);
        },

        overlayLeave(el, done) {
            const tl = gsap.timeline({
                onComplete: () => {
                    this.activeOverlayClass = false;
                },
            });

            tl
                .to(this.bg, {
                    duration: 1,
                    autoAlpha: 0,
                    ease: 'power3.inOut',
                })
                .to(this.triggerButton, {
                    duration: 1,
                    y: window.innerWidth < 768 ? 0 : 0,
                    x: window.innerWidth < 768 ? 0 : 0,
                    ease: 'power4.inOut',
                }, '<')
                .to(this.triggerButtonIcon, {
                    duration: 1,
                    rotate: 0,
                    ease: 'power3.inOut',
                }, '<')
                .to(this.overlayContainer, {
                    duration: 1,
                    yPercent: window.innerWidth < 768 ? 100 : 0,
                    x: window.innerWidth < 768 ? 0 : window.innerWidth,
                    ease: 'power4.inOut',
                    onComplete: () => {
                        if (window.matchMedia('(min-width: 768px)').matches) {
                            gsap.to(this.$el.querySelector('.overlay__trigger-text'), { duration: 1, autoAlpha: 1, ease: 'power4.out' });
                        }
                    },
                }, '<')
                .to([this.title, this.text, this.person, this.contact], {
                    duration: 1,
                    autoAlpha: 0,
                    y: 20,
                    ease: 'power4.inOut',
                    onComplete: done,
                }, '<');
        },

        triggerMouseEnter() {
            gsap.to(this.triggerButton, {
                duration: 0.3,
                scale: 1.2,
                ease: 'power4.out',
            });
        },

        triggerMouseLeave() {
            gsap.to(this.triggerButton, {
                duration: 0.3,
                scale: 1,
                ease: 'power4.out',
            });
        },
    },
});
